import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Consultas from "@/pages/Consultas.jsx";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/consultas" element={<Consultas />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
